var map = {
	"./auto-esporte.jpg": 229,
	"./caras.jpg": 230,
	"./crescer.jpg": 231,
	"./epoca-negocios.jpg": 232,
	"./epoca.jpg": 233,
	"./galileu.jpg": 234,
	"./go-outside.jpg": 235,
	"./istoe-dinheiro.jpg": 236,
	"./istoe.jpg": 237,
	"./marie-claire.jpg": 238,
	"./pegn.jpg": 239,
	"./rolling-stone.jpg": 240,
	"./selecoes.jpg": 241,
	"./vogue.jpg": 242
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 106;